import { render, staticRenderFns } from "./SupplierGroupEditView.vue?vue&type=template&id=a8f6b000"
import script from "./SupplierGroupEditView.vue?vue&type=script&lang=js"
export * from "./SupplierGroupEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports